import { useCallback, useEffect, useState } from 'react';
import { lclClient } from '../api/lclClient';

export function useLclCollisions(date_reglement) {
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  const refetch = useCallback(async () => {
    if (!date_reglement) { setData([]); return; }
    setLoading(true); setError(null);
    try {
      const d = await lclClient.listCollisions(date_reglement);
      setData(d || []);
    } catch (e) {
      setError(e.message || String(e));
    } finally {
      setLoading(false);
    }
  }, [date_reglement]);

  useEffect(() => { refetch(); }, [refetch]);

  return { data, loading, error, refetch };
}
